export default "__VITE_ASSET__DhRWDEGL__"